import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  customTool: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginTop: '5px'
  },
  disableImportLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  dialogModal: {
    '& .MuiPaper-root': {
      marginLeft: '10px',
      '& .makeStyles-dialogTitle-37': {
        padding: '16px 12px !important',
      },
      maxWidth: '1900px'
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  disableIcon: {
    pointerEvents: 'none',
    color: 'rgba(0, 0, 0, 0.26)'
  },
  importLabel: {
    fontWeight: 700,
    fontSize: '0.875rem',
    cursor: 'pointer',
  },
  invalidRow: {
    backgroundColor: '#ffcccc !important'
  },
  entryLabel: {
    marginLeft: '13px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));
export default styles;
